module.exports = __webpack_public_path__ + "img/logo_moneygram1.27b84734.png";